export const deviceSerial = (serial: string) => {
  const error = serial.substring(0, 5)
  if (error === 'ERROR') {
    return 'ERROR'
  } else {
    return serial
  }
}

export const deviceImage = (model: string) => {
  if (model.toLowerCase().includes("basic")) {
    return 'https://firebasestorage.googleapis.com/v0/b/index-braille.appspot.com/o/embossers%2Fbasic_v5.webp?alt=media&token=7133a484-53c1-436d-9aa2-78ab67b54b68'
  } else if (model.toLowerCase().includes("everest")) {
    return 'https://firebasestorage.googleapis.com/v0/b/index-braille.appspot.com/o/embossers%2Feverest_v5.webp?alt=media&token=d4aa02da-4821-4392-bbbb-31d2a92f9fd7'
  } else if (model.toLowerCase().includes("braillebox")) {
    return 'https://firebasestorage.googleapis.com/v0/b/index-braille.appspot.com/o/embossers%2Fbraillebox_v5.webp?alt=media&token=0ce65e6d-e949-41b8-942c-97b519a27ce4'
  } else if (model.toLowerCase().includes("fanfold")) {
    return 'https://firebasestorage.googleapis.com/v0/b/index-braille.appspot.com/o/embossers%2Ffanfold_v5.webp?alt=media&token=1e0a4f42-e2da-476e-a8cf-5f31dd7071ac'
  } else if (model.toLowerCase().includes("pageblaster")) {
    return 'https://firebasestorage.googleapis.com/v0/b/index-braille.appspot.com/o/embossers%2Faph_pageblaster.webp?alt=media&token=df967a64-6d04-4755-aba5-ec33807b4258'
  } else if (model.toLowerCase().includes("juliet")) {
    return 'https://firebasestorage.googleapis.com/v0/b/index-braille.appspot.com/o/embossers%2Fjuliet.webp?alt=media&token=5693862e-33d3-41ba-90e2-1abab485d99f'
  } else if (model.toLowerCase().includes("romeo")) {
    return 'https://firebasestorage.googleapis.com/v0/b/index-braille.appspot.com/o/embossers%2Fromeo.webp?alt=media&token=7a68c481-b401-48b3-ae15-4d83c06f0f1f'
  } else {
    return ''
  }
}

export const deviceApp = (model: string) => {
  switch (model) {
    case 'APH PageBlaster':
      return 'aph'

    case 'ETC Juliet 120':
    case 'ETC Romeo 60':
      return 'etc'

    default:
        return 'indexbraille'
  }
}